export enum ETypeUser {
  CLIENT,
  APPRENANT,
  FORMATEUR
}

export enum EAccessState {
  NONE,
  CONSULT,
  UPDATE
}
